export default {
  // 全局配置
  setOptions: {
    chart: {
      spacing: 20,
      backgroundColor: '#08153D'
    },
    credits: { // 版权信息
      enabled: false
    },
    title: { // 标题
      text: null
    },
    legend: {
      enabled: false,
      layout: 'horizontal',
      align: 'left',
      verticalAlign: 'top',
      itemStyle: {
        color: '#3A8BE6',
        fontsize: '14px'
      }
    },
    plotOptions: {
      column: {
        borderWidth: 0
      },
      line: {
        lineWidth: 1,
        marker: {
          radius: 3
        }
      }
    },
    xAxis: {
      lineWidth: 1,
      lineColor: '#162F7B',
      gridLineWidth: 0,
      labels: {
        style: {
          color: '#C5D3FF',
          fontSize: '14px'
        }
      }
    },
    yAxis: {
      lineWidth: 1,
      lineColor: '#162F7B',
      title: {text: null},
      labels: {
        style: {
          color: '#C5D3FF',
          fontSize: '14px'
        }
      },
      gridLineColor: '#162F7B',
      gridLineDashStyle: 'LongDash'
    }
  },
  // 折线图
  lineOptions: {
    chart: {
    },
    colors: ['#286CE3'],
    tooltip: {
    },
    yAxis: {
      tickInterval: 20
    },
    xAxis: {
      categories: []
    },
    plotOptions: {
      series: {
      }
    },
    series: [{
      name: '注册用户数',
      data: []
    }]
  },
  // 柱状图
  columnOptions: {
    chart: {
      type: 'column',
      options3d: {
        enabled: true,
        alpha: 0,
        beta: 0,
        depth: 20
      }
    },
    colors: [{ // 调色板
      linearGradient: [0, 0, 0, 200],
      stops: [[0, '#3BB6FF'], [1, '#264EDD']]
    }],
    plotOptions: {
      column: {
        depth: 25
      }
    },
    yAxis: {
      tickInterval: 2
    },
    xAxis: {
      categories: []
    },
    series: [{
      name: '新增用户',
      data: []
    }]
  },
  // 堆叠柱状图
  stackColOptions: {
    chart: {
      type: 'column'
    },
    colors: ['#3A8BE6', '#916BFE', '#15DB75', '#F8665D', '#F98F3B', '#95D515', '#0ACCB4', '#FFC292', '#5AA8BC'],
    legend: {
      enabled: true,
      padding: 4,
      symbolRadius: 1,
      itemDistance: 1,
      itemHoverStyle: {
        color: '#C5D3FF'
      }
    },
    xAxis: {
      categories: []
    },
    yAxis: {
      tickInterval: 50
    },
    tooltip: {
      shared: false
    },
    plotOptions: {
      column: {
        stacking: 'normal'
      }
    },
    series: [
      {
        name: '人脸',
        data: []
      },
      {
        name: '蓝牙',
        data: []
      },
      {
        name: '远程',
        data: []
      },
      {
        name: '密码',
        data: []

      },
      {
        name: '刷卡',
        data: []
      },
      {
        name: '云对讲',
        data: []
      },
      {
        name: '室内对讲',
        data: []
      },
      {
        name: '室内远程',
        data: []
      },
      {
        name: '电话开门',
        data: []
      }
    ]
  },
  // 实时开门
  realOpenOptions: {
    chart: {
    },
    colors: ['#3A8BE6', '#916BFE', '#15DB75', '#F8665D', '#F98F3B', '#95D515', '#0ACCB4', '#FFC292', '#5AA8BC'],
    yAxis: {
    },
    xAxis: {
      categories: []
    },
    legend: {
      enabled: true,
      itemHoverStyle: {
        color: '#C5D3FF'
      }
    },
    plotOptions: {
      line: {
        pointStart: 0
      }
    },
    series: [
      {
        name: '人脸',
        data: []
      },
      {
        name: '蓝牙',
        data: []
      },
      {
        name: '远程',
        data: []
      },
      {
        name: '密码',
        data: []
      },
      {
        name: '刷卡',
        data: []
      },
      {
        name: '云对讲',
        data: []
      },
      {
        name: '室内对讲',
        data: []
      },
      {
        name: '室内远程',
        data: []
      },
      {
        name: '电话开门',
        data: []
      }
    ],
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom'
          }
        }
      }]
    }
  },
  // 报修统计
  repairOptions: {
    chart: {
      type: 'variablepie',
      margin: 0,
      marginRight: 200,
      backgroundColor: 'transparent'
    },
    colors: ['#916BFE', '#F98F3B', '#15DB75', '#F8665D'],
    legend: {
      enabled: true,
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      x: -40,
      itemMarginTop: 10,
      symbolRadius: '1px',
      squareSymbol: false,
      symbolWidth: 22,
      symbolPadding: 10,
      itemHoverStyle: {
        color: '#C5D3FF'
      },
      itemStyle: {
        color: '#3A8BE6',
        fontsize: '14px'
      },
      labelFormatter () {
        return `<span
         style="font-family:Roboto;
         font-size:14px;
         font-weight:100">
        ${this.name}
        </span>
        <span style="color:#C5D3FF;
        font-size:16px;
        font-family: DINAlternate-Bold">
        ${this.y}%
        </span>`;
      }
    },
    tooltip: {
      headerFormat: '',
      pointFormatter () {
        return `<span style="color: ${this.color}">${this.name}</span>：<br>
                    <span>${this.y}%</span>`;
      }
    },
    plotOptions: {
      variablepie: {
        size: '90%',
        borderWidth: 0,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      }
    },
    series: [{
      colorByPoint: true,
      innerSize: '45%',
      size: '100%',
      data: []
    }]
  },
  // 饼状图
  pieOptions () {
    return {
      chart: {
        margin: 0
      },
      colors: ['#B8A0FF', '#8158F7', '#FFC292', '#F98F3B'],
      title: {
        floating: true
      },
      tooltip: {
        formatter () {
          return `<span style="color:${this.color}">${this.key}</span>：<br>
        <span style="font-family:DINAlternate-Bold">${this.y}%</span>`;
        }
      },
      plotOptions: {
        pie: {
          size: '80%',
          cursor: 'pointer',
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            // inside: true,
            distance: 2,
            padding: 0,
            connectorPadding: 0,
            rotation: 0,
            crop: false,
            overflow: 'none',
            color: '#C5D3FF',
            connectorColor: '#286CE3',
            useHtml: true,
            style: {fontSize: '14px', fontWeight: 'normal', textOutline: 'none'},
            formatter () {
              return `<span style="color:#286CE3">${this.key}</span><br>
            <span style="font-family:DINAlternate-Bold">${this.y}%</span>`;
            }

          }
        }
      },
      series: [{
        type: 'pie',
        innerSize: '65%',
        name: '累计终端',
        data: []
      }]
    };
  }
};



// WEBPACK FOOTER //
// ./src/js/chartOptions.js